import React from "react";
import styled from "styled-components";

const FormButton = ({ children, ...props }) => {
  return (
    <IconBtn {...props}>
      {children}
    </IconBtn>
  );
};

const IconBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  
  &:hover {
    background-color: var(--aia-bx-bright-blue-5);
  }
`;

export default FormButton;